import { formatTimestamp } from '../../../utils';
var DateCell = function (_a) {
    var value = _a.value;
    if (value) {
        return formatTimestamp(value, 'MM/DD/YYYY');
    }
    return '-';
};
export default DateCell;
